import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

const STORE_PROFIT_MARGIN_UPDATE_MUTATION = gql`
  mutation StoreProfitMarginUpdate_Shared_Mutation($input: StoreProfitMarginUpdateInput!) {
    storeProfitMarginUpdate(input: $input) {
      store {
        id
        discount
        profitMargin
      }
      errors {
        message
        fields {
          profitMargin
        }
      }
    }
  }
`;

interface StoreProfitMarginUpdateData {
  store: { id: string; discount: number; profitMargin };
  errors: { message };
}

interface Variables {
  input: {
    attributes: {
      profitMargin: number;
    };
  };
}

const useStoreProfitMarginUpdateMutation = (
  options?: MutationHookOptions<StoreProfitMarginUpdateData, Variables>
) =>
  useMutation<StoreProfitMarginUpdateData, Variables>(STORE_PROFIT_MARGIN_UPDATE_MUTATION, options);

export type { StoreProfitMarginUpdateData };
export { useStoreProfitMarginUpdateMutation, STORE_PROFIT_MARGIN_UPDATE_MUTATION };
